// extracted by mini-css-extract-plugin
export default {"error__container":"styles_error__container__REGcD","error-title__text":"styles_error-title__text__PjQXM"};